var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6872 17.3906L14.9626 32.3323C15.0556 33.4823 16.0095 34.3448 17.1749 34.3448H17.1833H40.2602H40.2644C41.3664 34.3448 42.3075 33.5364 42.4641 32.4635L44.4733 18.7989C44.5198 18.4739 44.4374 18.1489 44.2364 17.8864C44.0376 17.6218 43.7457 17.451 43.4158 17.4052C42.9738 17.4218 24.6303 17.3968 13.6872 17.3906ZM17.1706 37.4698C14.3852 37.4698 12.0269 35.3281 11.8006 32.5885L9.86326 9.89268L6.67593 9.35101C5.81089 9.20101 5.2335 8.39476 5.38155 7.54268C5.53383 6.6906 6.36926 6.13643 7.21526 6.26976L11.6145 7.01976C12.323 7.14268 12.8623 7.72185 12.9237 8.43018L13.4207 14.2656C43.6146 14.2781 43.7119 14.2927 43.8578 14.3093C45.0359 14.4781 46.0723 15.0843 46.7787 16.0177C47.4851 16.9489 47.7812 18.0968 47.612 19.2468L45.6048 32.9093C45.2263 35.5093 42.9336 37.4698 40.2687 37.4698H40.2581H17.1875H17.1706Z",
    fill: "#808D9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8675 25.0913H31.0047C30.127 25.0913 29.4185 24.3913 29.4185 23.5288C29.4185 22.6663 30.127 21.9663 31.0047 21.9663H36.8675C37.7431 21.9663 38.4538 22.6663 38.4538 23.5288C38.4538 24.3913 37.7431 25.0913 36.8675 25.0913Z",
    fill: "#808D9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2606 43.1289C16.8972 43.1289 17.4112 43.6352 17.4112 44.2622C17.4112 44.8893 16.8972 45.3977 16.2606 45.3977C15.6219 45.3977 15.1079 44.8893 15.1079 44.2622C15.1079 43.6352 15.6219 43.1289 16.2606 43.1289Z",
    fill: "#808D9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_814_20735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 43,
    width: 3,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1069 44.2618C15.1069 44.8909 15.6209 45.3993 16.2617 45.3993C16.8983 45.3993 17.4123 44.8909 17.4123 44.2618C17.4123 43.6347 16.8983 43.1284 16.2617 43.1284C15.6209 43.1284 15.1069 43.6347 15.1069 44.2618Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_814_20735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53418 55.814H27.9875V32.7119H4.53418V55.814Z",
    fill: "#808D9E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2588 43.8352C16.0198 43.8352 15.8252 44.0268 15.8252 44.2622C15.8252 44.7352 16.6945 44.7352 16.6945 44.2622C16.6945 44.0268 16.4978 43.8352 16.2588 43.8352ZM16.2588 46.9602C14.7487 46.9602 13.522 45.7497 13.522 44.2622C13.522 42.7747 14.7487 41.5664 16.2588 41.5664C17.7689 41.5664 18.9977 42.7747 18.9977 44.2622C18.9977 45.7497 17.7689 46.9602 16.2588 46.9602Z",
    fill: "#808D9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.119 43.1289C40.7556 43.1289 41.2717 43.6352 41.2717 44.2622C41.2717 44.8893 40.7556 45.3977 40.119 45.3977C39.4803 45.3977 38.9663 44.8893 38.9663 44.2622C38.9663 43.6352 39.4803 43.1289 40.119 43.1289Z",
    fill: "#808D9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_814_20735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 43,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9663 44.2618C38.9663 44.8909 39.4803 45.3993 40.119 45.3993C40.7535 45.3993 41.2717 44.8909 41.2717 44.2618C41.2717 43.6347 40.7535 43.1284 40.119 43.1284C39.4803 43.1284 38.9663 43.6347 38.9663 44.2618Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_814_20735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3911 55.814H51.8466V32.7119H28.3911V55.814Z",
    fill: "#808D9E"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1167 43.8352C39.8798 43.8352 39.6852 44.0268 39.6852 44.2622C39.6874 44.7393 40.5545 44.7352 40.5524 44.2622C40.5524 44.0268 40.3557 43.8352 40.1167 43.8352ZM40.1167 46.9602C38.6066 46.9602 37.3799 45.7497 37.3799 44.2622C37.3799 42.7747 38.6066 41.5664 40.1167 41.5664C41.6289 41.5664 42.8578 42.7747 42.8578 44.2622C42.8578 45.7497 41.6289 46.9602 40.1167 46.9602Z",
    fill: "#808D9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDarkIcon);
export default __webpack_public_path__ + "static/media/order-dark-icon.ebfd2d786cf9d4eb20995d8f950125ca.svg";
export { ForwardRef as ReactComponent };